import api from './api';
import type {
  DadosAgendamentoFeedbackContract,
  SubmeterAgendamentoFeedbackPayloadContract,
  SubmeterAgendamentoFeedbackResponseContract,
} from '@sstexames/shared-types';

export const feedbackService = {
  /**
   * Busca dados para a tela de avaliação pós-agendamento por token
   */
  async getDados(token: string): Promise<DadosAgendamentoFeedbackContract> {
    const response = await api.get<DadosAgendamentoFeedbackContract>(
      `/feedback/${token}`,
    );
    return response.data;
  },

  /**
   * Submete a avaliação de satisfação e experiência
   */
  async submeterFeedback(
    token: string,
    payload: SubmeterAgendamentoFeedbackPayloadContract,
  ): Promise<SubmeterAgendamentoFeedbackResponseContract> {
    const response = await api.post<SubmeterAgendamentoFeedbackResponseContract>(
      `/feedback/${token}`,
      payload,
    );
    return response.data;
  },
};
